"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchWithCSRFToken = void 0;
function fetchWithCSRFToken(url, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const completeOptions = Object.assign(Object.assign({}, options), { headers: Object.assign({ csrftoken: window.ocm.config.CSRFToken || "" }, options.headers) });
        let response;
        try {
            response = yield fetch(url, completeOptions);
        }
        catch (e) {
            console.error(e);
            return { httpStatus: 503 };
        }
        const csrfToken = response.headers.get("csrftoken");
        if (csrfToken)
            window.ocm.config.CSRFToken = csrfToken;
        const responseData = { httpStatus: response.status };
        try {
            const returnJson = yield response.json();
            Object.assign(responseData, returnJson);
        }
        catch (e) {
            console.error(e);
        }
        return responseData;
    });
}
exports.fetchWithCSRFToken = fetchWithCSRFToken;
